document.addEventListener("DOMContentLoaded", () => {
  console.log("🎧 Vault Player script loaded");

  // Ensure WaveSurfer is available
  if (typeof WaveSurfer === "undefined") {
    console.error("❌ WaveSurfer not loaded");
    return;
  }

  const tracks = document.querySelectorAll(".vp-track");
  if (!tracks.length) {
    console.warn("⚠️ No .vp-track elements found.");
    return;
  }

  console.log("🎧 Vault Player initialized");
  const players = [];

  tracks.forEach((track) => {
    const src = track.dataset.src;
    const waveContainer = track.querySelector(".vp-track__wave");
    const playBtn = track.querySelector(".vp-play-btn");

    const ws = WaveSurfer.create({
      container: waveContainer,
      waveColor: "#333",
      progressColor: "#facc15",
      cursorColor: "#facc15",
      height: 80,
      barWidth: 2,
      barGap: 2,
      responsive: true,
      normalize: true,
    });

    ws.load(src);

    ws.on("ready", () => console.log("✅ Track ready:", src));

    ws.on("finish", () => {
      playBtn.textContent = "▶";
    });

    playBtn.addEventListener("click", () => {
      players.forEach((p) => {
        if (p !== ws && p.isPlaying()) {
          p.pause();
          p._button.textContent = "▶";
        }
      });

      if (ws.isPlaying()) {
        ws.pause();
        playBtn.textContent = "▶";
      } else {
        ws.play();
        playBtn.textContent = "⏸";
      }
    });

    ws._button = playBtn;
    players.push(ws);
  });
});
